import React from 'react'
import { IconMapMarkerAlt, IconEnvelope, IconPhone, IconGithub, IconLinkedin } from './Icons'

const Footer = () => {
  return (
    <div>
        


        <footer className="main-footer rel z-1" style={{ background: '#080B11', borderTop: '1px solid rgba(255, 255, 255, 0.08)' }}>
      <div className="footer-top-wrap pt-40 pb-25">
          <div className="container">
              <div className="row">
                  <div className="col-lg-4 col-md-12 mb-4 mb-lg-0">
                      <div className="footer-widget widget_logo wow fadeInUp delay-0-2s">
                          <div className="footer-logo mb-3">
                               <a href="/" onClick={() => window.location.href = '/'} style={{ fontSize: '26px', fontWeight: '800', color: '#F8FAFC', textDecoration: 'none' }}>
                                   Manoj <span style={{ color: '#38BDF8' }}>Parmar</span>
                               </a>
                          </div>
                          <p style={{ color: '#94A3B8', fontSize: '15px', lineHeight: '1.6' }}>
                            Senior Full-Stack Software Engineer specializing in scalable web applications, enterprise databases, Next.js, MERN stack, MySQL, and Python.
                          </p>
                      </div>
                  </div>
                  <div className="col-lg-4 col-md-7 mb-4 mb-lg-0">
                      <div className="footer-widget widget_nav_menu wow fadeInUp delay-0-4s">
                          <h6 className="footer-title" style={{ color: '#F8FAFC', fontSize: '18px', fontWeight: '700' }}>Quick Links</h6>
                          <ul className="d-flex flex-wrap gap-3" style={{ listStyle: 'none', padding: 0 }}>
                              <li><a href="#home" style={{ color: '#94A3B8', textDecoration: 'none' }}>Home</a></li>
                              <li><a href="#about" style={{ color: '#94A3B8', textDecoration: 'none' }}>About</a></li>
                              <li><a href="#resume" style={{ color: '#94A3B8', textDecoration: 'none' }}>Experience</a></li>
                              <li><a href="#skills" style={{ color: '#94A3B8', textDecoration: 'none' }}>Skills</a></li>
                              <li><a href="#portfolio" style={{ color: '#94A3B8', textDecoration: 'none' }}>Projects</a></li>
                              <li><a href="#contact" style={{ color: '#94A3B8', textDecoration: 'none' }}>Contact</a></li>
                          </ul>
                      </div>
                  </div>
                  <div className="col-lg-4 col-md-5">
                      <div className="footer-widget widget_contact_info wow fadeInUp delay-0-6s">
                          <h6 className="footer-title" style={{ color: '#F8FAFC', fontSize: '18px', fontWeight: '700' }}>Contact Info</h6>
                          <ul style={{ listStyle: 'none', padding: 0 }}>
                              <li className="mb-2" style={{ color: '#94A3B8' }}><IconMapMarkerAlt className="me-2" /> Ahmedabad, Gujarat, India</li>
                              <li className="mb-2"><IconEnvelope className="me-2" /> <a href="mailto:manojparmar6161@gmail.com" style={{ color: '#94A3B8', textDecoration: 'none' }}>manojparmar6161@gmail.com</a></li>
                              <li className="mb-2"><IconPhone className="me-2" /> <a href="tel:+917038595952" style={{ color: '#94A3B8', textDecoration: 'none' }}>+91 7038595952</a></li>
                          </ul>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div className="footer-bottom py-3" style={{ borderTop: '1px solid rgba(255, 255, 255, 0.05)' }}>
          <div className="container">
             <div className="row align-items-center">
                 <div className="col-lg-6">
                      <div className="copyright-text">
                          <p className="mb-0" style={{ color: '#64748B', fontSize: '14px' }}>© 2026 <a href="#home" style={{ color: '#38BDF8', textDecoration: 'none' }}>Manoj Parmar</a>. All Rights Reserved.</p>
                      </div>
                 </div>
                  <div className="col-lg-6 text-lg-end">
                      <ul className="footer-bottom-nav d-inline-flex gap-4 mb-0" style={{ listStyle: 'none' }}>
                          <li>
                              <a href="https://github.com/ManojParmar7" target="_blank" rel="noopener noreferrer" style={{ color: '#94A3B8', textDecoration: 'none' }}>
                                  <IconGithub className="me-1" /> GitHub
                              </a>
                          </li>
                          <li>
                              <a href="https://in.linkedin.com/in/manoj-parmar-267777167" target="_blank" rel="noopener noreferrer" style={{ color: '#94A3B8', textDecoration: 'none' }}>
                                  <IconLinkedin className="me-1" /> LinkedIn
                              </a>
                          </li>
                      </ul>
                  </div>
             </div>
          </div>
      </div>
  </footer>
    </div>
  )
}

export default Footer